// extracted by mini-css-extract-plugin
export default {"deleteModalButtons":"Modals_deleteModalButtons__+9zsm","inputGap":"Modals_inputGap__i+1fT"};